import React, { ReactNode } from 'react';
import classes from './StyledList.module.scss';
import clsx from 'clsx';
export interface Props {
  children: ReactNode;
  listStyle?: string;
}

export const StyledList: React.FC<Props> = ({ children, listStyle }) => {
  return (
    <ul className={clsx(classes.root, listStyle === 'promise' && classes.promiseStyle)}>
      {children}
    </ul>
  );
};

export default StyledList;
